"use strict";
/* tslint:disable:max-classes-per-file */

exports.__esModule = true;
var LogLevel;

(function (LogLevel) {
  LogLevel[LogLevel["Trace"] = 5] = "Trace";
  LogLevel[LogLevel["Debug"] = 4] = "Debug";
  LogLevel[LogLevel["Info"] = 3] = "Info";
  LogLevel[LogLevel["Warn"] = 2] = "Warn";
  LogLevel[LogLevel["Error"] = 1] = "Error";
  LogLevel[LogLevel["Fatal"] = 0] = "Fatal";
})(LogLevel = exports.LogLevel || (exports.LogLevel = {}));

var Log =
/** @class */
function () {
  function Log(owner, appenders) {
    this.owner = owner;
    this.appenders = appenders;
  }

  Log.prototype.trace = function (message) {
    var optionalParams = [];

    for (var _i = 1; _i < arguments.length; _i++) {
      optionalParams[_i - 1] = arguments[_i];
    }

    return this.append(LogLevel.Trace, Array.prototype.slice.call(arguments));
  };

  Log.prototype.debug = function (message) {
    var optionalParams = [];

    for (var _i = 1; _i < arguments.length; _i++) {
      optionalParams[_i - 1] = arguments[_i];
    }

    return this.append(LogLevel.Debug, Array.prototype.slice.call(arguments));
  };

  Log.prototype.info = function (message) {
    var optionalParams = [];

    for (var _i = 1; _i < arguments.length; _i++) {
      optionalParams[_i - 1] = arguments[_i];
    }

    return this.append(LogLevel.Info, Array.prototype.slice.call(arguments));
  };

  Log.prototype.warn = function (message) {
    var optionalParams = [];

    for (var _i = 1; _i < arguments.length; _i++) {
      optionalParams[_i - 1] = arguments[_i];
    }

    return this.append(LogLevel.Warn, Array.prototype.slice.call(arguments));
  };

  Log.prototype.error = function (message) {
    var optionalParams = [];

    for (var _i = 1; _i < arguments.length; _i++) {
      optionalParams[_i - 1] = arguments[_i];
    }

    return this.append(LogLevel.Error, Array.prototype.slice.call(arguments));
  };

  Log.prototype.fatal = function (message) {
    var optionalParams = [];

    for (var _i = 1; _i < arguments.length; _i++) {
      optionalParams[_i - 1] = arguments[_i];
    }

    return this.append(LogLevel.Fatal, Array.prototype.slice.call(arguments));
  };

  Log.prototype.append = function (level, logArgs) {
    var _this = this;

    if (logArgs === void 0) {
      logArgs = [];
    }

    try {
      this.appenders.forEach(function (appender) {
        var event = new LogEvent(level, _this.owner, new Date(), logArgs);
        appender.append(event);
      });
      return this;
    } catch (e) {
      return this;
    }
  };

  return Log;
}();

exports.Log = Log;
var defaultAppenders = [];

var LogManager =
/** @class */
function () {
  function LogManager() {}

  LogManager.getLog = function (owner) {
    return new Log(owner, defaultAppenders);
  };

  LogManager.addAppender = function (appender) {
    defaultAppenders.push(appender);
  };

  return LogManager;
}();

exports.LogManager = LogManager;

var LogEvent =
/** @class */
function () {
  function LogEvent(level, prefix, timeStamp, logArgs) {
    this.level = level;
    this.prefix = prefix;
    this.timeStamp = timeStamp;
    this.logArgs = logArgs;
  }

  return LogEvent;
}();

exports.LogEvent = LogEvent;

var ConsoleLogAppender =
/** @class */
function () {
  function ConsoleLogAppender(level) {
    if (level === void 0) {
      level = LogLevel.Error;
    }

    this.level = level;
  }

  ConsoleLogAppender.prototype.append = function (logEvent) {
    if (logEvent.level > this.level) {
      return;
    }

    if (!logEvent.logArgs) {
      logEvent.logArgs = [];
    }

    logEvent.logArgs.unshift(logEvent.timeStamp.toISOString());
    logEvent.logArgs.unshift(logEvent.prefix);

    switch (logEvent.level) {
      case LogLevel.Trace:
        {
          console.trace.apply(console, logEvent.logArgs);
          break;
        }

      case LogLevel.Debug:
        {
          console.log.apply(console, logEvent.logArgs);
          break;
        }

      case LogLevel.Info:
        {
          console.info.apply(console, logEvent.logArgs);
          break;
        }

      case LogLevel.Warn:
        {
          console.warn.apply(console, logEvent.logArgs);
          break;
        }

      case LogLevel.Error:
        {
          console.error.apply(console, logEvent.logArgs);
          break;
        }

      case LogLevel.Fatal:
        {
          console.error.apply(console, logEvent.logArgs);
          break;
        }
    }
  };

  return ConsoleLogAppender;
}();

exports.ConsoleLogAppender = ConsoleLogAppender;